import { Button } from 'component/Button'
import { OptionButton } from 'component/ProfileOptions/OptionButton'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { action } from 'mobx'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { Photo } from 'type/Options'

export const ProfileOptions = observer(() => {
  const order: Photo[] = opt.irnby ? ['full', 'selfie', 'simple'] : ['selfie', 'simple', 'full']

  const onContinue = useLatestCallback(action(() => {
    controller.selectProfile(undefined)
    if (store.profile) {
      store.profile.isNew = true
      store.profile.type = store.createPhoto
      store.profile.common.userPhoto.clear()
    }
    controller.editProfile()
    store.profile.simple.stage = 'selfie'
    controller.closeCreateProfile()
  }))

  return (
    <Vertical gap={16}>
      <Vertical gap={12}>
        {order.map(photo => {
          const show = opt.photo.includes(photo)
          return show && <OptionButton key={photo} photo={photo} />
        })}
      </Vertical>
      <Button large round={8} height={40} primary action={onContinue}>
        {i18n('Continue')}
      </Button>
    </Vertical>
  )
})
